import { Type } from "class-transformer";
import ResponseEntity, { InputEntity } from "../..";
import {
  IsInt,
  IsDate,
  ValidateNested,
  IsString,
  IsBoolean,
  ValidateIf,
} from "class-validator";
import OutputLc from "../../lc";

export default class TransmedReceiving extends ResponseEntity {
  @IsInt() public readonly id!: number;

  @Type(() => OutputLc)
  @ValidateNested()
  public readonly lc!: OutputLc;

  @ValidateIf((obj) => obj.accomodation_yes !== null)
  @IsInt()
  public readonly accomodation_yes!: number | null;

  @ValidateIf((obj) => obj.accomodation_no !== null)
  @IsInt()
  public readonly accomodation_no!: number | null;

  @Type(() => Date)
  @IsDate()
  public readonly exchange_start!: Date;
  @Type(() => Date)
  @IsDate()
  public readonly exchange_end!: Date;

  @IsString() public readonly whatsapp!: string;
  @IsString() public readonly acceptance_message!: string;
  @IsBoolean() public readonly payment!: boolean;
}

export class TransmedReceivingInput extends InputEntity {
  public constructor(
    public readonly lc: string,
    public readonly accomodation_yes: number | null,
    public readonly accomodation_no: number | null,
    public readonly exchange_start: Date,
    public readonly exchange_end: Date,
    public readonly whatsapp: string,
    public readonly acceptance_message: string,
    public readonly payment: boolean
  ) {
    super();
  }
}
